import styled from 'styled-components';
import { colors } from '../../style/colors';
import { SubH } from '../../style/typography';

const TagContainer = styled.div`
  width: 8rem;
  background-color: ${props => props.color};
  text-align: center;
`;

const TagTitle = styled(SubH)`
  padding: 0.6rem 0;
  color: ${props =>
    props.color === colors.MINT ? colors.WHITE : colors.BLACK} !important;
`;

export { TagContainer, TagTitle };
